<template>
  <SimpleLoadingChartContainer
    :chartOptions="ciiHistoryChartOptions"
    :loading="ciiHistoryLoading"
    loadingText="Loading Historical CII Chart..."
    :elevation="3"
  >
    <template #header>
      <h3 class="chart-title">Historical CII</h3>
    </template>
  </SimpleLoadingChartContainer>
</template>

<script>
import SimpleLoadingChartContainer from "../../../core/SimpleLoadingChartContainer.vue";
import { mapGetters, mapState } from "vuex";
export default {
  name: "HistoricalCiiChart",
  components: {
    SimpleLoadingChartContainer,
  },

  computed: {
    ...mapState("cii", ["ciiHistoryLoading"]),
    ...mapGetters("cii", ["ciiHistoryChartOptions"]),
  },
};
</script>

<style scoped>
.chart-title {
  color: var(--color-text);
}
</style>